import React from 'react';
import Col from '../../Col';
import Row from '../../Row';
import Input from '../../Input';
import { ResolvedAddress, useGeocoder } from '../hooks/useGeocoder';

interface PropertyAddressSectionProps {
  addressLine1: string;
  city: string;
  province: string;
  postalCode: string;
  errors: {
    addressLine1?: string;
    city?: string;
    province?: string;
    postalCode?: string;
  };
  onChange: (update: any) => void;
  onClearErrorField: (fieldName: string) => void;
}

const PropertyAddressSection = ({
  addressLine1,
  city,
  province,
  postalCode,
  errors,
  onChange,
  onClearErrorField,
}: PropertyAddressSectionProps) => {
  const { location, predictions, getLocation, onClickLocation } = useGeocoder({
    onAddressResolved: (resolved: ResolvedAddress) => onChange(resolved),
  });

  return (
    <>
      <Input
        value={location}
        onChange={(e: any) => getLocation(e.target.value)}
        label="Search Location"
        block
        placeholder="Search Location"
      />
      {predictions.map((item: any, index: number) => (
        <div
          key={index}
          className="location_search"
          onClick={() => onClickLocation(item.description)}
        >
          {item.description}
        </div>
      ))}
      <Input
        value={addressLine1}
        onChange={(e: any) => onChange({ addressLine1: e.target.value })}
        label="Address"
        required
        placeholder="eg., 123 Example Street"
        block
        errors={errors.addressLine1}
      />
      <Row>
        <Col xs="12" md="4">
          <Input
            value={city}
            onChange={(e: any) => onChange({ city: e.target.value })}
            label="City"
            required
            placeholder="eg., Vancouver"
            block
            errors={errors.city}
          />
        </Col>
        <Col xs="12" md="4">
          <Input
            value={province}
            onChange={(e: any) => onChange({ province: e.target.value })}
            label="Province"
            required
            placeholder="eg., BC"
            block
            errors={errors.province}
          />
        </Col>
        <Col xs="12" md="4">
          <Input
            value={postalCode}
            onChange={(e: any) => {
              onClearErrorField('postalCode');
              onChange({ postalCode: e.target.value });
            }}
            label="Postal Code"
            required
            placeholder="eg., A0A 0A0"
            block
            errors={errors.postalCode}
          />
        </Col>
      </Row>
    </>
  );
};

export default PropertyAddressSection;
